export const Banner = () => {
  return (
    <div className="banner">
      <div className="banner__content">
        <div className="txt">
          <div className="txt__content" id="banner-text">
            <h1>DESIERTO AUSTRAL</h1>
            <p>COLECCIÓN <strong>VERANO 23</strong></p>
            <div className="btn-black left">
              <a href="https://www.hakahonu.cl/desierto-austral.html" target='_parent' id='C0.1'>VER MÁS</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
